import firebase from "firebase";
import "firebase/storage";

export async function uploadImageToFireStorage(
  uid: string,
  file: File,
  name: string,
  uniqueName?: string,
  fileType?: string,
) {
  const storageRef = firebase.storage().ref();
  const metadata = {
    contentType: fileType || null,
  };
  const userUidRef = storageRef.child(`${uid}/${uniqueName}/${name}`);
  return await userUidRef
    .put(file, metadata)
    .then((snapshot) => {
      return { success: true, snapshot };
    })
    .catch(() => {
      return { success: false };
    });
}

export async function getImageUrlFromFireStorage(filePath: string) {
  const storageRef = firebase.storage().ref();
  var forestRef = storageRef.child(`${filePath}`);

  var data = await forestRef
    .getDownloadURL()
    .then((metadata) => {
      return { success: true, metadata };
    })
    .catch((error) => {
      console.log(error);
      return { success: false };
    });
  // console.log("data :>> ", data);

  return data;
}

export async function getDocumentMetadata(filePath: string) {
  const storageRef = firebase.storage().ref();
  var forestRef = storageRef.child(`${filePath}`);

  var data = await forestRef
    .getMetadata()
    .then((metadata) => {
      return { success: true, metadata };
    })
    .catch((error) => {
      return { success: false };
    });

  return data;
}
